import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import WorkflowScopeGate from 'components/inboundReferrals/WorkflowScopeGate';

import { TASKS_ROUTES } from './constants';

type Props = {
  children: React.ReactNode;
};

// The tasks deep link's scope check, delegated to WorkflowScopeGate: the workflow
// arrives as `?task=<id>` rather than a path segment, because the tasks route cannot
// grow a sibling route without remounting the page (see App.tsx — that teardown closes
// users' portal tabs).
//
// Only the task the URL ARRIVED with is checked — captured once on mount. The page
// syncs the param as slideouts open and close, and re-running the check on every open
// would swap the page for a spinner mid-session (a remount, the exact thing the query
// param exists to avoid). Anything opened from within the page is already scope-safe:
// the lists only offer the acting client's work.
export default function TasksDeepLinkScopeGate({ children }: Props) {
  const [searchParams] = useSearchParams();
  const [initialTask] = useState(() => searchParams.get('task'));

  return (
    <WorkflowScopeGate workflowId={initialTask} fallbackPath={TASKS_ROUTES.BASE}>
      {children}
    </WorkflowScopeGate>
  );
}
